<template>
    <div class="modal fade" id="geoservicesModal" tabindex="-1" aria-labelledby="geoservicesModalLabel"
        aria-hidden="true" @mousedown.self="closeModal">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="geoservicesModalLabel">
                        Geoservicios WMS y WFS
                    </h1>
                    <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="service-section">
                                <h4 class="service-title">
                                    <i class="fas fa-map me-2"></i>
                                    Servicio WMS (Web Map Service)
                                </h4>
                                <p class="service-description">
                                    Es un estándar de protocolo para servir imágenes de mapas geo-referenciadas a través
                                    de Internet.
                                    No es un formato de archivo, sino un servicio que permite a los clientes (como
                                    software GIS)
                                    solicitar y recibir mapas de un servidor en tiempo real.
                                </p>
                                <div class="url-container">
                                    <label class="form-label fw-bold">URL Servicio WMS:</label>
                                    <div>
                                        <a href="https://catastrominero.sanjuan.gob.ar/geoserver/wms" target="_blank"
                                            rel="noopener noreferrer" class="link-geoservice">
                                            https://catastrominero.sanjuan.gob.ar/geoserver/wms
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="service-section">
                                <h4 class="service-title">
                                    <i class="fas fa-vector-square me-2"></i>
                                    Servicio WFS (Web Feature Service)
                                </h4>
                                <p class="service-description">
                                    Es un estándar del Open Geospatial Consortium (OGC) que permite acceder, consultar y
                                    modificar
                                    datos geográficos vectoriales a través de Internet. A diferencia del WMS, que
                                    devuelve una imagen,
                                    un WFS proporciona los datos vectoriales brutos (puntos, líneas y polígonos) y sus
                                    atributos.
                                </p>
                                <div class="url-container">
                                    <label class="form-label fw-bold">URL Servicio WFS:</label>
                                    <div>
                                        <a href="https://catastrominero.sanjuan.gob.ar/geoserver/wfs" target="_blank"
                                            rel="noopener noreferrer" class="link-geoservice">
                                            https://catastrominero.sanjuan.gob.ar/geoserver/wfs
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GeoservicesModal",
    methods: {
        closeModal() {
            const modalElement = document.getElementById('geoservicesModal');
            const backdrop = document.getElementById('geoservices-backdrop');
            if (modalElement) {
                modalElement.classList.remove('show');
                modalElement.style.display = 'none';
                modalElement.setAttribute('aria-hidden', 'true');
            }
            if (backdrop) {
                backdrop.remove();
            }
            document.body.classList.remove('modal-open');
        }
    }
};
</script>

<style scoped>
.service-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    border-left: 4px solid #ff6b35;
}

.service-title {
    color: #ff6b35;
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.service-description {
    color: #6c757d;
    line-height: 1.6;
    margin-bottom: 20px;
    text-align: justify;
}

.url-container {
    margin-top: 15px;
}

.form-label {
    color: #495057;
    margin-bottom: 8px;
}

.input-group input {
    background-color: #fff;
    border: 1px solid #dee2e6;
    font-family: 'Courier New', monospace;
    font-size: 0.9rem;
}

.btn-outline-secondary:hover {
    background-color: #6c757d;
    border-color: #6c757d;
}

.modal-header {
    background: linear-gradient(135deg, #ff6b35, #ff8c5a);
    color: white;
    border-bottom: none;
}

.modal-header .btn-close {
    filter: invert(1);
}

.modal-title {
    font-weight: 600;
}

.modal-footer {
    border-top: 1px solid #dee2e6;
    background-color: #f8f9fa;
}

@media (max-width: 768px) {
    .modal-dialog {
        margin: 10px;
    }

    .service-section {
        padding: 15px;
    }

    .service-title {
        font-size: 1.1rem;
    }

    .input-group input {
        font-size: 0.8rem;
    }
}
</style>